import { ComponentPropsWithRef } from "react";
import { CircularSvg } from "./PlayIcon.Parts";

export const PlayIcon = ({ ref, ...props }: ComponentPropsWithRef<"svg">) => (
  <CircularSvg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM14.5 20.3301L20.5 16.866C21.1667 16.4811 21.1667 15.5189 20.5 15.134L14.5 11.6699C13.8333 11.285 13 11.7661 13 12.5359V19.4641C13 20.2339 13.8333 20.715 14.5 20.3301Z"
      fill="currentColor"
    />
  </CircularSvg>
);
